import { DropdownPaginated } from 'components/commons';
import React, { useCallback } from 'react';
import { useApi } from 'hooks';
import { getAccountCategories } from 'apis/account.api';

const SelectCategory = ({ placeholder = '', ...props }) => {
  const {
    request,
    loading,
    result = { accountCategories: [], count: 0 }
  } = useApi({
    api: getAccountCategories,
    pageError: true
  });

  const fetch = useCallback(
    async (params) => {
      return await request({
        perPage: 10,
        ...params
      });
    },
    [request]
  );

  return (
    <DropdownPaginated
      {...props}
      request={async (params) => {
        return await fetch(params);
      }}
      total={result.count}
      loading={loading}
      formatRequest={(result) => {
        const { accountCategories = [] } = result || {};
        if (accountCategories && accountCategories.length > 0) {
          const newCategories = accountCategories;

          return newCategories.map((d) => {
            return {
              label: d.name,
              value: d.accountCategoryId
            };
          });
        }
        return [];
      }}
      placeholder={placeholder}
    />
  );
};

export default SelectCategory;
